import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import showToast from "../../Global/Hooks/toast";
import PhoneInput from "react-phone-number-input";
import {useDispatch, useSelector} from "react-redux";
import Popup from "../Popup";
import Input from "../../UI/Input";
import { setLoader } from "../../Store/Slice/techsbookSlice";
import useInputHandler from "../../Global/Hooks/inputHandler";
import useEmailValidation from "../../Global/Hooks/emailValidation";
import useGetJobs from "../../Global/Api/Jobs/getJobs.api";
import { useLazyEditJobPrimaryContactQuery } from "../../Store/Builder/jobs.api";

export const EditJobPrimaryContact = ({close}) => {
    const {title: jobTitle} = useParams();
    const dispatch = useDispatch();
    const Jobs = useGetJobs({ allList: false });
    const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);
    const {firstname, lastname, phone, email} = activeJob?.contacts?.filter(el => el?.type === 'primary')[0];

    const [editJobPrimaryContact] = useLazyEditJobPrimaryContactQuery()

    const firstName = useInputHandler();
    const lastName = useInputHandler();
    const emailValidation = useEmailValidation();
    const [phoneValue, setPhoneValue] = useState(phone);

    const handleEmailChange = (event) => {
        emailValidation.handleChange(event);
        emailValidation.validateEmail(event.target.value);
    };

    const setContactData = () => {
        firstName.setChange(firstname);
        lastName.setChange(lastname);
        emailValidation.setChange(email);
        setPhoneValue(phone || '');
    };

    useEffect(() => {
        setContactData();
    }, [activeJob]);

    const handleSaveContact = async (e) => {
        e.preventDefault();

        const body = {
            firstname: firstName?.value,
            lastname: lastName?.value,
            phone: phoneValue,
            email: emailValidation?.value,
        }

        try {
            dispatch(setLoader(true));
            await editJobPrimaryContact({id: activeJob?.id, body}).unwrap();
            showToast('Job primary contact successfully edited!', 'success');
            await Jobs.getById(jobTitle);
            dispatch(setLoader(false));
        } catch (e) {
            showToast(e?.data?.message, 'error');
            dispatch(setLoader(false));
        }

        close();
    };

    return (
        <Popup
            title="Edit Primary Point of contact"
            closePopup={close}
            contentStyles={{width: '580px'}}
            headStyles={{borderBottom: 'none'}}
        >
            <form onSubmit={handleSaveContact} className="edit-job-desc-modal contact">
                <div className="edit-job-desc-modal_body">
                    <div className="edit-job-desc-modal_inputs">
                        <Input
                            label="First name"
                            placeholder="Enter first name"
                            type="text"
                            id="first_name"
                            {...firstName}
                        />
                        <Input
                            label="Last name"
                            placeholder="Enter last name"
                            type="text"
                            id="last_name"
                            {...lastName}
                        />
                    </div>
                    <div className="edit-job-desc-modal_inputs">
                        <div>
                            <label htmlFor="phone" className='input-phone-number-label'>Phone Number</label>
                            <PhoneInput
                                id="phone"
                                placeholder="Enter phone number"
                                value={phoneValue}
                                onChange={setPhoneValue}
                                className="personal__input__phone"
                            />
                        </div>
                        <Input
                            label="Email"
                            placeholder="Enter email"
                            type="email"
                            id="email"
                            value={emailValidation.value}
                            handleChange={handleEmailChange}
                        />
                    </div>
                </div>
                <div className="edit-job-desc-modal_foot">
                    <button className="edit-job-desc-modal_foot_cancel" onClick={close}>Cancel</button>
                    <button className="edit-job-desc-modal_foot_save" type="submit">Save</button>
                </div>
            </form>
        </Popup>
    )
}
